import { atom } from "recoil";

const recommendationsState = atom({
    key: "recommendationsState",
    default: true
});

export { recommendationsState };
